import { z } from 'zod';
import { imageWithUploadSchema } from '../../common';

export const conditionTypeSchema = z.enum(['']);
export const conditionSchema = z.object({
  id: conditionTypeSchema,
});

export const contractQuotationSchema = z.object({
  ref: z.string(),
  pdfImage: imageWithUploadSchema,
  conditions: z.array(conditionSchema),
});

export type ContractQuotation = z.infer<typeof contractQuotationSchema>;
